import React from 'react';
import styles from './CloseButton.module.scss';

const CloseButton = ({ light, ...props }) => {
    return (
        <button
            className={`icon-close-thin ${styles.closeButton} ${light ? styles.light : ''}`}
            type={'button'}
            {...props}
        />
    );
};

export default CloseButton;
